import { useEffect } from "react";
import { useMutation } from "convex/react";
import { api } from "../../convex/_generated/api";

const PushNotificationOpenSync = () => {
  const markRead = useMutation(api.notifications.markRead);

  useEffect(() => {
    const url = new URL(window.location.href);
    const notificationId = url.searchParams.get("__notificationId");
    if (!notificationId) return;

    markRead({ id: notificationId })
      .catch((err) => {
        console.warn("[push] Failed to mark notification read:", err);
      })
      .finally(() => {
        url.searchParams.delete("__notificationId");
        window.history.replaceState(window.history.state, "", url.toString());
      });
  }, [markRead]);

  return null;
};

export default PushNotificationOpenSync;
